export function createCustomEvent(type: string, detail: any): Event {
  return new CustomEvent(type, {
    detail,
    bubbles: true,
  });
}
